/// <reference path="../../common/forms/forms.ts" />

namespace OfficeGuy.Apps {
    export class PurchasePages {
        static ModifyCart(Event, CompanyIdentifier, CustomerID, CustomerKey, CatalogIdentifier, CartID, ItemID, Quantity, Increment, RefreshPage = false, ClearCart = false): boolean {
            Event.preventDefault();
            Event.stopPropagation();
            Common.AjaxRequest({
                URL: "/modifycart/",
                ShowLoading: true,
                Data:
                {
                    CompanyIdentifier: CompanyIdentifier,
                    CatalogIdentifier: CatalogIdentifier,
                    CustomerID: CustomerID,
                    CustomerKey: CustomerKey,
                    ItemID: ItemID,
                    Quantity: Quantity == null ? 0 : Quantity,
                    Increment: Increment == null ? true : Increment,
                    CartID: CartID,
                    Store: true,
                    RefreshPage: RefreshPage == null ? false : RefreshPage,
                    ClearCart: ClearCart == null ? false : ClearCart
                }
            });
            return false;
        }
        static ShowSetQuantity($Element) {
            var $Modal = Modals.ShowInputDialog({
                Title: OfficeGuy.Resources.GetString("PurchasePages", "UpdateQuantity_Title"),
                InputClass: "input-Int64",
                DefaultValue: $Element.val(),
                ConfirmEvent: function (Quantity) {
                    if (Quantity == 0)
                        OfficeGuy.Forms.NestedForm_Remove('.og-purchasepages-payment-items', 'Cart.Items', $Element.closest(".og-purchasepages-payment-items-item").index());
                    else
                        $Element.val(Quantity);
                    return PurchasePages.SubmitFormPreventPayment();
                },
                Simple: true
            });
            var $Input = $Modal.find("input");
            $Input.wrap($("<div>")
                .addClass("og-purchasepages-payment-setquantity"));
            $Input
                .before($('<a>')
                    .addClass("og-button-ui-action og-button-ui-action-extrasmallicon og-button-color-grayborder")
                    .click(function () {
                        $Input.val(Math.max(0, Number($Input.val()) - 1));
                    })
                    .append($('<span class="icon-sumit-minus"></span>'))
                )
                .after($('<a>')
                    .addClass("og-button-ui-action og-button-ui-action-extrasmallicon og-button-color-grayborder")
                    .click(function () {
                        $Input.val(Number($Input.val()) + 1);
                    })
                    .append($('<span class="icon-sumit-plus"></span>'))
                );
            return false;
        }
        static ShowSetPrice($Element) {
            Modals.ShowInputDialog({
                Title: OfficeGuy.Resources.GetString("PurchasePages", "UpdatePrice_Title"),
                Message: OfficeGuy.Resources.GetString("PurchasePages", "UpdatePrice_Message"),
                InputClass: "input-Int64",
                DefaultValue: $Element.val(),
                ConfirmEvent: function (UnitPrice) {
                    $Element.val(UnitPrice);
                    return PurchasePages.SubmitFormPreventPayment();
                }
            });
            return false;
        }
        static ShowSetRecurrence($Options, $Element) {
            Modals.ShowHTMLDialog({
                HTML: $Options,
                Title: "בחירת תקופת חיוב",
                Buttons: [
                    $(document.createElement('input'))
                        .attr('type', 'button')
                        .addClass('og-button-ui-action og-button-color-submit')
                        .val('אישור')
                        .on('click', function () {
                            var Recurrence = $Options.find("input[type=hidden]").val();
                            $Element.val(Recurrence);
                            return PurchasePages.SubmitFormPreventPayment();
                        })
                ],
            });
            return false;
        }
        
        static SubmitFormPreventPayment() {
            Modals.HideAll(false, function () {
                var $Form = $('form');
                $Form.find("#PreventPayment").val("true");
                Forms.SubmitFormSkipValidation($Form);
            });
            return false;
        }
        static SetCustomerSendingIndication(CompanyIdentifier, CustomerIdentifier, CustomerKey, Join) {
            Common.AjaxRequest({
                URL: "/updates/",
                Data: {
                    CompanyIdentifier: CompanyIdentifier,
                    CustomerIdentifier: CustomerIdentifier,
                    CustomerKey: CustomerKey,
                    Join: Join
                },
                ShowLoading: true,
            });
            return false;
        }
        static CancelRecurring(CompanyIdentifier, CustomerIdentifier, CustomerKey, CatalogIdentifier, Cancel) {
            Common.AjaxRequest({
                URL: "/cancelrecurring/",
                Data:
                {
                    CompanyIdentifier: CompanyIdentifier,
                    CustomerIdentifier: CustomerIdentifier,
                    CustomerKey: CustomerKey,
                    CatalogIdentifier: CatalogIdentifier,
                    Cancel: Cancel
                }
            });
        }
        static ItemURL_CatalogChanged($EntityPicker) {
            var Data = Teva.SelectBox.GetInstance($EntityPicker).SelectedData;
            var Name = Data == null || !Data.AdditionalFields || !Data.AdditionalFields["PurchasePages.PurchasePages.DocumentDefinitionEnum"] ? $(".purchasepages-resultdocument").data("defaulttype") : Data.AdditionalFields["PurchasePages.PurchasePages.DocumentDefinitionEnum"];
            $(".purchasepages-resultdocument").text("סוג המסמך שיופק בתשלום: " + Name);
        }
        static RefreshCustomAmount() {
            var CustomAmount = Number($('#CustomAmount').val());
            $('.og-purchasepages-payment-customamount-active').removeClass("og-purchasepages-payment-customamount-active");
            $('.og-purchasepages-payment-customamount').filter(function() { return $(this).data("customamount") == CustomAmount }).addClass("og-purchasepages-payment-customamount-active");
        }
        static RefreshCustomAmountRecurrence() {
            var CustomAmountRecurrence = Number($('#CustomAmountRecurrence').val());
            $('.og-purchasepages-payment-customamountrecurrence-active').removeClass("og-purchasepages-payment-customamountrecurrence-active");
            $('.og-purchasepages-payment-customamountrecurrence').filter(function() { return $(this).data("customamountrecurrence") == CustomAmountRecurrence }).addClass("og-purchasepages-payment-customamountrecurrence-active");
        }

    }
}